import {Component} from '@angular/core';
import {CameraConfiguration} from '../../../../../../shared/models/vehicle.model';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {delay} from 'rxjs/operators';
import {of} from 'rxjs';

const DEFAULT_CAMERA_CONFIGURATION = {
  localRecording: {
    captureEnabled: true,
    captureImageInterval: 10
  },
  rotation: 0,
  streaming: {
    observationCapture: true,
    captureImageInterval: 10,
    captureStreamDuration: -1
  }
} as CameraConfiguration;

@Component({
  selector: 'app-camera-configuration',
  imports: [],
  templateUrl: './camera-configuration.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CameraConfigurationComponent
    },
  ]
})
export class CameraConfigurationComponent implements ControlValueAccessor {

  configuration: CameraConfiguration;

  constructor() {
  }

  writeValue(obj: CameraConfiguration) {
    this.configuration = obj;
    if (!this.configuration) {
      of(null).pipe(
        delay(10)
      ).subscribe(() => {
        this.configuration = DEFAULT_CAMERA_CONFIGURATION;
        this.onTouchedListener();
        this.onChangeListener(this.configuration);
      });
    }
  }

  onChangeListener = _ => {
  }

  onTouchedListener = () => {
  }

  registerOnChange(fn: any) {
    this.onChangeListener = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedListener = fn;
  }

  setDisabledState(isDisabled: boolean) {
    // ignore
  }

}
